import { useGetApiV1Company } from '@/shared/api/generated';

/**
 * Busca uma única empresa pelo `id` via `/v1/company` (query param `CompanyId`)
 * para obter o `name` a exibir como valor inicial do autocomplete de empresa
 * no formulário de Série — `SerieViewModel` só retorna `companyId`, sem rótulo.
 *
 * @param companyId - Id da empresa; quando `undefined`, a busca fica desabilitada.
 * @returns `{ companyName, isLoading }`.
 */
export function useCompanyById(companyId: number | undefined) {
  const { data, isLoading } = useGetApiV1Company(
    companyId != null ? { CompanyId: companyId } : undefined,
    { query: { enabled: companyId != null } },
  );

  return { companyName: data?.data?.[0]?.name ?? undefined, isLoading } as const;
}
